"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardPhotoHeader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _PropertyCardPhotoHeader = require("./PropertyCardPhotoHeader.styles");
/**
 * A container that appears at the top of a property photo in a `PropertyCard`.
 * Usually contains a `PropertyCard.Badge`.
 *
 * @since 8.63.0
 */
var PropertyCardPhotoHeader = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_PropertyCardPhotoHeader.StyledPropertyCardPhotoHeader, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.PropertyCardPhotoHeader = PropertyCardPhotoHeader;
PropertyCardPhotoHeader.displayName = 'PropertyCard.PhotoHeader';